import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VsIconComponent } from './vs-icon.component';
import { ShieldIconComponent } from './shield-icon.component';

@NgModule({
  declarations: [VsIconComponent, ShieldIconComponent],
  imports: [
    CommonModule
  ],
  exports: [VsIconComponent, ShieldIconComponent]
})
export class FGBIconsModule {
  static forRoot() {
    return {
      ngModule: FGBIconsModule,
      providers: []
    };
  }
}
